export default __webpack_public_path__ + "static/media/element_spec_59.d09665df.webp";